export const ATTACHMENT_TEXT = {
  unathorizedLimit: {
    passedLimit: {
      text: "+ 1 processo apensado",
      subtext:
        "Você não tem acesso a um dos processos em apenso porque ele é privado. Entre em contato com o seu advogado caso precise visualizar.",
    },
    inLimit: {
      text: "1 processo apensado",
      subtext:
        "Você não tem acesso ao processo em apenso porque ele é privado. Entre em contato com o seu advogado caso precise visualizar.",
    },
  },
};
